import React, { memo, useEffect } from 'react';
import {
  RequestGmnLocationReview,
  UpdateReplyParams,
} from '../../../../requests/company/gmb-location-reviews';

import ReviewList from '../../../general/gmb-location-reviews/ReviewList';
import ReviewSearchBox from '../../../general/gmb-location-reviews/ReviewSearchBox';
import Spinner from 'react-bootstrap/Spinner';

import { RequestGmbLocation } from '../../../../requests/company/gmb-locations';
import { useGmbLocationReviewSearch } from '../../../../hooks/useGmbLocationReviewSearch';

type Props = {
  specifiedGmbLocationId?: number;
  gmbLocationReviewManagementPath: string;
  replyInitialStatus: boolean | undefined;
};

const CompanyReviewList: React.FC<Props> = (props) => {
  const { specifiedGmbLocationId, replyInitialStatus } = props;
  const { isLoading, queries, pagination, gmbLocationReviews, refresh, updateQuery } =
    useGmbLocationReviewSearch({
      specifiedGmbLocationId,
      requestGmbLocationReviews: RequestGmnLocationReview.list,
      replyInitialStatus,
    });

  useEffect(() => {
    refresh(queries.currentPage, {
      gmbLocationId: queries.gmbLocationId,
      replied: queries.replied,
      rate: queries.rate,
    });
  }, [queries.currentPage, queries.gmbLocationId, queries.replied, queries.rate]);

  if (gmbLocationReviews === undefined) {
    return <Spinner animation="border" role="status" />;
  }

  const handleUpdateReply = async (id: number, params: UpdateReplyParams): Promise<void> => {
    await RequestGmnLocationReview.updateReply(id, params);
  };

  return (
    <>
      <ReviewSearchBox
        selectedItems={{
          gmbLocationId: queries.gmbLocationId,
          rate: queries.rate,
          replied: queries.replied,
        }}
        updateQuery={updateQuery}
        handleGmbLocationRequest={RequestGmbLocation.search}
        gmbLocationReviewManagementPath={props.gmbLocationReviewManagementPath}
      />
      <ReviewList
        isLoading={isLoading}
        queries={queries}
        pagination={pagination}
        gmbLocationReviews={gmbLocationReviews}
        fetchLocationReviews={refresh}
        handleUpdateReply={handleUpdateReply}
        paginationPath={'/company/gmb_location_reviews'}
        gmbLocationReviewManagementPath={props.gmbLocationReviewManagementPath}
        handleGmbLocationKeyword={RequestGmbLocation.keywords}
      />
    </>
  );
};

export default memo(CompanyReviewList);
